import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteGroupsParams {
  ids: string[];
}

export interface IDeleteGroupsResult extends IResult {
}

export class DeleteGroupsRequest extends Request<IDeleteGroupsParams, IDeleteGroupsResult> {
  constructor(ids: string[]) {
    super('deleteGroups', { ids: ids });
  }
}
